export const PROMETHEE_RESOURCE_GROUP_PATTERN =
  /^Promethee:(Read|Create|Update|Delete):([A-Za-z][A-Za-z0-9]*)$/;

export const isPrometheeResourceGroupName = (groupName) =>
  PROMETHEE_RESOURCE_GROUP_PATTERN.test(groupName);

export const parsePrometheeResourceGroupName = (groupName) =>
  PROMETHEE_RESOURCE_GROUP_PATTERN.exec(groupName);
